module.exports = __webpack_public_path__ + "img/Global_College_of_PME.d583de63.jpeg";